import { RefObject, useEffect } from 'react';
import useSessionTimeout from '../../../hooks/useSessionTimeout';
import { IPqDataEntryFormProps } from '../../../types/shared/PrequalificationDataEntry';
import { initializePQSetup, AcquisitionFlow } from '../../../utils/acquisition-utils';

/**
 * - Acquistions is initialized
 * - Session Storage items are removed from other flows
 * - Black Box is initialized
 */
export default function usePqdeSetup(
    pageRef: RefObject<HTMLDivElement>,
    author: IPqDataEntryFormProps['author'],
) {
    useSessionTimeout(pageRef, AcquisitionFlow.PQ);

    useEffect(() => {
        initializePQSetup(author);
    }, [author]);
}
